import { map } from 'rxjs/operators';
import { Component, OnDestroy } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { SettingsService } from '../../services/settings.service';
import { SubscriptionManager } from '@zelis/platform-ui-components';
import { PcpDeselectOverlayComponent } from './pcp-deselect-overlay.component';
import { PcpService } from './pcp.service';
import { PcpSettings } from '@interfaces/pcp-settings.model';
import { Disclaimer } from '@components/disclaimers';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pcp-message',
  templateUrl: './pcp-message.component.html',
})
export class PcpMessageComponent implements OnDestroy {
  public showPcpMessage: boolean = false;
  public pcpDisclaimers: Disclaimer[];
  private showDeselectLink: boolean = false;
  private dialogRef: MatDialogRef<PcpDeselectOverlayComponent>;
  private deselectLink: string;
  private subscriptions = new SubscriptionManager();

  constructor(
    private dialog: MatDialog,
    private settingsService: SettingsService,
    private pcpService: PcpService,
    private translateService: TranslateService
  ) {
    this.subscriptions.add(this.getPcpDisclaimers());
  }

  ngOnDestroy() {
    this.subscriptions.destroy();
  }

  public openDeselectOverlay(): void {
    this.dialogRef = this.dialog.open(PcpDeselectOverlayComponent, {
      data: this,
      width: '500px',
      panelClass: 'pcp-deselect-overlay',
      backdropClass: 'search-overlay-backdrop',
    });
  }

  public handleOnClick(event: MouseEvent): void {
    const targetElement = event.target as HTMLElement;
    if (targetElement.tagName === 'A') {
      this.openDeselectOverlay();
    }
  }

  private getPcpDisclaimers(): Subscription {
    return combineLatest([
      this.getPcpSetting(),
      this.getSuppressPcpClearSetting(),
    ]).subscribe(([pcpSettings, suppressPcpClear]: [PcpSettings, boolean]) => {
      if (pcpSettings?.showHomepageMessage) {
        this.deselectLink = this.pcpService.buildDeselectionLink(pcpSettings);
        this.showDeselectLink = this.pcpService.isLinkbackUrlSet(pcpSettings);
        this.addPcpDisclaimers(suppressPcpClear);
        this.showPcpMessage = true;
      }
    });
  }

  private addPcpDisclaimers(suppressPcpClear: boolean): void {
    this.pcpDisclaimers = [
      new Disclaimer({
        text: 'app_global_pcp_message',
        level: 3,
        expanded: true,
      }),
    ];
    if (!suppressPcpClear && this.showDeselectLink) {
      this.pcpDisclaimers.push(
        new Disclaimer({
          text:
            '<a>' +
            this.translateService.instant('app_global_pcp_clear') +
            '</a>',
          level: 3,
          expanded: true,
        })
      );
    }
  }

  private getSuppressPcpClearSetting(): Observable<boolean> {
    return this.settingsService.getSetting('suppress_pcp_clear');
  }

  private getPcpSetting(): Observable<PcpSettings> {
    return this.settingsService
      .getSetting('pcp')
      .pipe(map((setting) => new PcpSettings(setting)));
  }
}
